import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {FacialBiometricsStore} from './types';

export const useFacialBiometricsStore = create<FacialBiometricsStore>()(
	persist(
		set => ({
			hasFacialBiometrics: false,
			registerLater: false,
			lastConsultedCdPessoa: '',
			isUnder16: false,
			isTea: false,
			guardians: [],
			setHasFacialBiometrics: value => set({hasFacialBiometrics: value}),
			setRegisterLater: value => set({registerLater: value}),
			setLastConsultedCdPessoa: value => set({lastConsultedCdPessoa: value}),
			setIsUnder16: value => set({isUnder16: value}),
			setIsTea: value => set({isTea: value}),
			setGuardians: value => set({guardians: value}),
			resetFacialBiometrics: () =>
				set({
					hasFacialBiometrics: false,
					registerLater: false,
					lastConsultedCdPessoa: '',
					isUnder16: false,
					isTea: false,
					guardians: [],
				}),
		}),
		{
			name: 'facialBiometricsData',
		},
	),
);
